//@flow
import { HiverAxios,toggleModal,AcknowledgeModal } from 'h-commons';
import {    
    ACCOUNT_DELETE_REASON_DONE,
    ACCOUNT_DELETE_REASON_FAILED,
    ACCOUNT_DELETE_REASON_INIT,
    ACCOUNT_DELETE_FAILED,
    SAVE_USER_DETAILS
} from './types';
import React from "react";

export const deleteAccountReason = (action: Object, done: Function) => (dispatch: Function) => {
    dispatch({
        type: ACCOUNT_DELETE_REASON_INIT
    });
    HiverAxios({
        url: '/api/account/delete/reason',
        type: 'POST',
        params: action,
        callback: resp => {
            if (resp.data && resp.data.success) {
                dispatch({
                    type: ACCOUNT_DELETE_REASON_DONE
                });
                done(action.actiontaken === 'delete');
            } else {
                dispatch({
                    type: ACCOUNT_DELETE_REASON_FAILED
                });
                done(false);
            }
        },
        onfail: () => {
            dispatch({
                type: ACCOUNT_DELETE_REASON_FAILED
            });
            done(false);
        }
    });
}   
export const deleteAccount = (gmailMode,triggerDelete,isTrial, phoneNumber='') => (dispatch: Function) => {
    const state  = ( triggerDelete ) ? 'initiateDelete' : 'cancelDeletion';
    HiverAxios({
        url: '/api/account/delete/initiate',
        type: 'POST',
        params: { confirm: true , state, phone_number: phoneNumber},
        callback: resp => {
            if (resp.data && resp.data.success) {
                dispatch({
                    type: SAVE_USER_DETAILS,
                    payload:{
                        "deletionActivated": triggerDelete
                    }
                });
                if(isTrial){
                    window.location.href = 'https://hiverhq.com';
                    return;
                }
                !triggerDelete && dispatch(toggleModal(<AcknowledgeModal shown={true} handleModalState={() => {
                    dispatch(toggleModal());
                }}/>));
            } else {
                dispatch({
                    type: ACCOUNT_DELETE_FAILED
                });
            }
        },
        onfail: () => {
            dispatch({
                type: ACCOUNT_DELETE_FAILED
            });
        }
    });
}